import type { NexxusUpdatePackageManifest } from './NexxusUpdateManifest';

const SHA256_HEX = /^[a-f0-9]{64}$/;

export interface PackageValidationResult {
  valid: boolean;
  errors: string[];
}

/** Valide la structure d'un manifeste de paquet `.nexxus-update`. */
export function validateNexxusUpdateManifest(input: unknown): PackageValidationResult {
  const errors: string[] = [];
  if (!input || typeof input !== 'object') {
    return { valid: false, errors: ['manifeste absent ou invalide'] };
  }
  const m = input as Partial<NexxusUpdatePackageManifest>;
  if (m.format !== 'nexxus-update') errors.push('format invalide');
  if (m.format_version !== 1) errors.push('format_version non supporté');
  if (!m.app_version || typeof m.app_version !== 'string') errors.push('app_version requis');
  if (!m.platform || typeof m.platform !== 'string') errors.push('platform requis');
  if (!m.architecture || typeof m.architecture !== 'string') errors.push('architecture requis');
  if (!m.channel || typeof m.channel !== 'string') errors.push('channel requis');
  if (!m.checksum_sha256 || !SHA256_HEX.test(m.checksum_sha256)) {
    errors.push('checksum_sha256 invalide');
  }
  if (!m.published_at || typeof m.published_at !== 'string') errors.push('published_at requis');
  if (!m.manifest_signature || typeof m.manifest_signature !== 'string') {
    errors.push('manifest_signature requise');
  }
  if (typeof m.mandatory !== 'boolean') errors.push('mandatory requis');
  return { valid: errors.length === 0, errors };
}

/** Construit un manifeste paquet depuis une release API. */
export function manifestFromLatestRelease(
  release: import('./NexxusUpdateManifest').LicensingLatestRelease,
): NexxusUpdatePackageManifest {
  return {
    format: 'nexxus-update',
    format_version: 1,
    app_version: release.version,
    platform: release.platform,
    architecture: release.architecture,
    channel: release.channel,
    checksum_sha256: release.checksum_sha256,
    download_url: release.download_url,
    // Repli informatif : l'ancien JWT est dans `manifest_jwt` (manifest_signature = signature détachée).
    manifest_signature: release.manifest_jwt ?? release.manifest_signature ?? '',
    mandatory: release.mandatory,
    minimum_supported_version: release.minimum_supported_version ?? undefined,
    local_schema_version: release.local_schema_version ?? undefined,
    api_compatibility: release.api_compatibility ?? undefined,
    published_at: release.published_at,
  };
}
